import { render, staticRenderFns } from "./mypage.vue?vue&type=template&id=5a176604&"
import script from "./mypage.vue?vue&type=script&lang=js&"
export * from "./mypage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports